<template>
  <!-- 여행버튼 관리자 페이지 for 지역별 썸네일 변경 -->
  <div>
    <div class="header-button-container" style="width: 100%"></div>
    <b-table striped hover :items="posts1" :fields="fields">
      <template v-slot:cell(cityName)="row">
        <b-form-textarea v-model="row.item.cityName" disabled />
      </template>
      <template v-slot:cell(thumbnail)="row">
        <b-img
          :src="row.item.thumbnail"
          @click="selectFile(row.item)"
          width="200"
          height="245"
        />
      </template>
    </b-table>

    <form ref="form">
      <input
        id="files"
        type="file"
        name="file"
        ref="uploadInput"
        accept="image/*"
        :multiple="false"
        @change="detectFiles($event)"
        style="display: hidden"
      />
    </form>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      fields: [
        { key: "cityName", label: "지역명" },
        { key: "thumbnail", label: "썸네일" },
      ],
      posts1: [],
      items: [],
      selectedItem: {}, // when you clicked img file
    };
  },
  mounted() {
    firebase
      .firestore()
      .collection("locations")
      .get()
      .then((snap) => {
        const testCollection = [];
        snap.forEach((doc, index) => {
          testCollection.push({ ...doc.data(), id: doc.id });
        });

        this.posts1 = testCollection.map((item) => {
          return {
            ...item,
          };
        });
      });
  },
  methods: {
    selectFile: function (selectedItem) {
      this.$refs.uploadInput.click();
      this.selectedItem = selectedItem;
      console.log(this.selectedItem);
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map((x) => {
        this._upload(fileList[0]);
      });
    },
    _upload(file) {
      const storageRef = firebase
        .storage()
        .ref("images")
        .child(file.name)
        .put(file);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          console.log((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.save({ ...this.selectedItem, thumbnail: url });
          });
        }
      );
    },
    save(item) {
      var result = {
        ...item,
      };

      firebase
        .firestore()
        .collection("locations")
        .doc(item.id)
        .update(result)
        .then(() => {
          console.log({ ...item });
          alert("수정을 성공적으로 완료 했습니다.");
        })
        .catch(() => {
          alert("수정에 실패 했습니다. 관리자에게 문의 하세요.");
        });
    },
  },
};
</script>

<style></style>
